(() => {
  class ProductGallery {
    constructor(section) {
      this.section = section;
      this.mainImage = section.querySelector('[data-product-main-image]');
      this.thumbnailButtons = Array.from(
        section.querySelectorAll('[data-product-thumbnail]')
      );
      this.handleThumbnailClick = this.handleThumbnailClick.bind(this);

      this.bindEvents();
    }

    bindEvents() {
      this.thumbnailButtons.forEach((button) => {
        button.addEventListener('click', this.handleThumbnailClick);
      });
    }

    handleThumbnailClick(event) {
      this.selectThumbnail(event.currentTarget);
    }

    selectThumbnail(button) {
      if (!this.mainImage || !button) return;

      const nextSrc = button.dataset.imageSrc;
      const nextSrcset = button.dataset.imageSrcset;
      const nextAlt = button.dataset.imageAlt || '';

      if (nextSrc) {
        this.mainImage.src = nextSrc;
      }

      if (nextSrcset) {
        this.mainImage.srcset = nextSrcset;
      } else {
        this.mainImage.removeAttribute('srcset');
      }

      this.mainImage.alt = nextAlt;

      this.thumbnailButtons.forEach((thumbnail) => {
        const isActive = thumbnail === button;

        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      this.thumbnailButtons.forEach((button) => {
        button.removeEventListener('click', this.handleThumbnailClick);
      });
    }
  }

  window.ProductGallery = {
    create(section) {
      return new ProductGallery(section);
    },
  };
})();
